import { normalizeOrganizationId } from 'src/app/shared/helper/organization-id';
import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Chart} from 'chart.js';
import {UserService} from 'src/app/shared/services/user.service';
import {UserConstant} from 'src/app/shared/constants/user-constant';
import {ApService} from 'src/app/shared/services/ap.service';
import {TemplateService} from 'src/app/shared/services/template.service';
import {forkJoin, Subscription} from 'rxjs';
import {TopnavbarService} from 'src/app/shared/services/topnavbar.service';
import {ActivatedRoute, NavigationEnd, Router, Event} from '@angular/router';

@Component({
  selector: 'app-device-report',
  templateUrl: './device-report.component.html',
  styleUrls: ['./device-report.component.scss']
})
export class DeviceReportComponent implements OnInit, OnDestroy {
  private pageAvailable: boolean = true;
  private initialized = false;
  orgCatDataSource: MatTableDataSource<any>;
  displayedOrgCatColumns: string[] = ['type', 'count'];

  chart: any;
  upDeviceCnt = 0;
  downDeviceCnt = 0;
  warnDeviceCnt = 0;
  pendingDeviceCnt = 0;
  templateDataSource: MatTableDataSource<any>;
  displayedTemplateColumns: string[] = ['t_type', 't_count', 't_device_count'];

  qosArray = [];
  prtgArray = [];
  wirelessArray = [];
  i4glteArray = [];
  teamsArray = [];

  parentId: any;
  hasParentOrg: any;
  arrReportUrl: any[];

  orgId: any;
  org: any;
  user: any;
  orgType = [
    "Master MSP", "MSP", "Organization"
  ]
  arrOverviewUrl: any[];

  orgDataSource: any[] = [];
  displayedOrgColumns: string[] = ['name', 'domain', 'role', 'subOrgs', 'subUsers', 'deviceCnt']
  allOrgData: any = null;
  deviceArray: any = [];
  jumpDataSource: any;
  length: any;

  loading = true;
  templatesLoading = true;
  historyLoading = false;
  loadError = '';
  templatesError = '';
  historyError = '';
  selectedReportTab = 0;
  private templatesLoaded = false;
  private historySubscription: Subscription;

  private loadDataSubscription: Subscription;
  private routerSubscription: Subscription;
  l_single_link: any;
  l_single_link_lte: any;
  l_failover: any;
  l_failover_lte: any;
  l_nfr: any;
  l_spare: any;
  l_overlay: any;
  l_cloud_dmz: any;
  l_wan_connect: any;
  l_1gb_lte_data: any;
  additionalLicenseCounts = [
    { key: 'ashield', label: 'Add-on: Attack Shield', color: '#d1495b', count: 0 },
    { key: 'SIPCID04', label: 'Add-on: Sipwatch - SIPCID04', color: '#6c5ce7', count: 0 },
    { key: 'SIPCID06', label: 'Add-on: Sipwatch - SIPCID06', color: '#0984a3', count: 0 },
    { key: 'SIPCID10', label: 'Add-on: Sipwatch - SIPCID10', color: '#a66b28', count: 0 },
    { key: 'SIPCID20', label: 'Add-on: Sipwatch - SIPCID20', color: '#d65f9e', count: 0 }
  ];
  chartLicense: any;
  parentOrg: any;

  constructor(
    public userService: UserService,
    public apService: ApService,
    private templateService: TemplateService,
    private topnavbarService: TopnavbarService,
    private ref: ChangeDetectorRef,
    private router: Router,
    public route: ActivatedRoute,
    private changeDetection: ChangeDetectorRef
  ) {
    this.orgCatDataSource = new MatTableDataSource<any>();
    this.templateDataSource = new MatTableDataSource<any>();

    this.routerSubscription = this.router.events.subscribe((event: Event) => {
      // NavigationEnd may arrive before ngOnInit has restored the user session.
      if (!(event instanceof NavigationEnd) || !this.initialized || !this.pageAvailable) return;
      const id = this.route.snapshot.paramMap.get('id');
      const nextOrgId = normalizeOrganizationId(id) || normalizeOrganizationId(this.user?.organization);
      if (nextOrgId === this.orgId) return;
      this.orgId = nextOrgId;
      this.parentId = nextOrgId;
      this.loadData();
    });
  }

  ngOnInit(): void {
    const storedUser = localStorage.getItem(UserConstant.USER);
    try {
      this.user = storedUser ? JSON.parse(storedUser) : null;
    } catch (_) {
      this.user = null;
    }
    const id = this.route.snapshot.paramMap.get('id');
    this.orgId = normalizeOrganizationId(id) || normalizeOrganizationId(this.user?.organization);
    this.parentId = this.orgId;
    this.initialized = true;
    this.loadData();
  }

  drawDeviceChart() {
    this.upDeviceCnt = this.deviceArray.filter(d => {
      return d.status == 'on'
    }).length
    this.warnDeviceCnt = this.deviceArray.filter(d => {
      return d.status == 'warn'
    }).length
    this.downDeviceCnt = this.deviceArray.filter(d => {
      return d.status == 'off'
    }).length
    this.chart?.destroy();
    this.chart = new Chart('canvas', {
      type: 'doughnut',
      data: {
        labels: ['Online', 'Offline', 'Warning', 'Pending'],
        datasets: [
          {
            data: [this.upDeviceCnt, this.downDeviceCnt, this.warnDeviceCnt, this.pendingDeviceCnt],
            backgroundColor: ['#34a854', 'rgb(255, 205, 86)', '#cf853e', '#b0b0b0'],
            fill: false
          },
        ]
      },
      options: {
        legend: {
          display: false
        },
        tooltips: {
          enabled: true
        }
      }
    });


  }

  getStatus(date, track) {
    if(track && track.length>0){      
      // if(track[0].lastDeviceState == "alert_on"){
      //   return "on"
      // }else if(track[0].lastDeviceState == "alert_off"){
      //   return "off"
      // } else {
      //   return track[0].lastDeviceState
      // } OLD TRACK STATUS
      if(track[0].lastDeviceState === 1){
        return "on"
      }else if(track[0].lastDeviceState === 2){
        return "warn"
      } else {
        return "off"
      }
    } else {
      const time = new Date(date);
      let cdate = new Date();
      let datedifferance = cdate.getTime() - time.getTime();
      if (datedifferance > 600e3) { // greater than 10 min
        return 'off';
      } else if(datedifferance < 600e3  && datedifferance > 300e3){
        return 'warn';
      } else {
        return 'on';
      }
    }
  }

  updateAdditionalLicenseCounts() {
    this.additionalLicenseCounts.forEach(license => {
      license.count = this.deviceArray.filter(device =>
        (device.addOnLicense || []).includes(license.key)).length;
    });
  }

  drawLicenseChart() {
    this.updateAdditionalLicenseCounts();
    this.l_single_link = this.deviceArray.filter(d => {
      return d.baseLicense == "1l"
    }).length
    this.l_single_link_lte = this.deviceArray.filter(d => {
      return d.baseLicense == "1l_lte"
    }).length
    this.l_failover = this.deviceArray.filter(d => {
      return d.baseLicense == "2l"
    }).length
    this.l_failover_lte = this.deviceArray.filter(d => {
      return d.baseLicense == "2l_lte"
    }).length
    this.l_nfr = this.deviceArray.filter(d => {
      return d.baseLicense == "nfr"
    }).length
    this.l_spare = this.deviceArray.filter(d => {
      return d.baseLicense == "spare"
    }).length
    this.l_overlay = this.deviceArray.filter(d => {
      return (d.addOnLicense || []).includes("overlay")
    }).length
    this.l_cloud_dmz = this.deviceArray.filter(d => {
      return (d.addOnLicense || []).includes("cloud_dmz")
    }).length
    this.l_wan_connect = this.deviceArray.filter(d => {
      return (d.addOnLicense || []).includes("wan_connect")
    }).length
    this.l_1gb_lte_data = this.deviceArray.filter(d => {
      return (d.addOnLicense || []).includes("lte_1g")
    }).length
    this.chartLicense?.destroy();
    this.chartLicense = new Chart('license', {
      type: 'doughnut',
      data: {
        labels: ['Single Link',
          'Single Link LTE',
          'Failover',
          'Failover LTE',
          'NFR',
          'Spare',
          'Add-on: Overlay',
          'Add-on: Cloud DMZ',
          'Add-on: WAN Connect',
          'Add-on: 1GB LTE Data',
          ...this.additionalLicenseCounts.map(license => license.label)],
        datasets: [
          {
            data: [this.l_single_link,
              this.l_single_link_lte,
              this.l_failover,
              this.l_failover_lte,
              this.l_nfr,
              this.l_spare,
              this.l_overlay,
              this.l_cloud_dmz,
              this.l_wan_connect,
              this.l_1gb_lte_data,
              ...this.additionalLicenseCounts.map(license => license.count)],
            backgroundColor: ['#fff100',
              '#ff8c00',
              '#e81123',
              '#ec008c',
              '#68217a',
              '#00188f',
              '#00bcf2',
              '#00b294',
              '#009e49',
              '#bad80a',
              ...this.additionalLicenseCounts.map(license => license.color)],
            fill: false
          },
        ]
      },
      options: {
        legend: {
          display: false
        },
        tooltips: {
          enabled: true
        }
      }
    });


  }

  setTopNavMenu() {
    if (!this.pageAvailable) return;
    //Set Report links
    if (this.router.url.includes('/layout/report')) {
      //Detect if page is in Billing or overview
      let page = this.router.url.includes('billing') ? "/layout/report/billing/" : "/layout/report/overview/";

      //Root link
      this.arrReportUrl = [
        {
          "route": page,
          "name": "Root",
          "type": "link",
        }];

      //Detect if org has sub-orgs or not
      if (this.hasParentOrg && this.hasParentOrg.length) {
        for (var i = 0; i < this.hasParentOrg.length; i++) {
          let tempData = {};

          //detect if org has role of 0 or not
          if (i === 0) {
            tempData = {
              "route": page,
              "name": this.hasParentOrg[i] ? this.hasParentOrg[i]['name'] : "",
              "type": "link"
            }
          } else {
            tempData = {
              "route": this.hasParentOrg[i] ? page + this.hasParentOrg[i]['name'] + '_' + this.hasParentOrg[i]['_id'] : page,
              "name": this.hasParentOrg[i] ? this.hasParentOrg[i]['name'] : "",
              "type": "link"
            }
          }

          this.arrReportUrl.push(tempData);
        }
      } else {
        //parent org
        this.arrReportUrl.push(
          {
            "route": this.org ? page + this.org['name'] + '_' + this.org['_id'] : page,
            "name": this.org ? this.org['name'] : "",
            "type": "link",
          }
        );
      }
      //Billing or Overview dropdown
      this.arrReportUrl.push({
        "route": "",
        "name": this.router.url.includes('billing') ? "Billing" : "Overview",
        "type": "dropdown",
        "sub": [
          {
            "route": this.getOverviewLink(),
            "name": "Overview",
            "type": "link",
          },
          {
            "route": this.getBillingLink(),
            "name": "Billing",
            "type": "link",
          }
        ]
      });
      this.topnavbarService.set(this.arrReportUrl)
    } else {
      //Set other links
      this.topnavbarService.set([
        {
          "route": "/layout/organization",
          "name": "Root",
          "type": "link",
        },
        {
          "route": "",
          "name": this.org ? this.org['name'] : "",
          "type": "text"
        }
      ])
    }
  }

  getOverviewLink() {
    if (this.orgId) {
      if (this.org.parentOrganization && typeof this.org.parentOrganization !== "undefined") {
        let org = this.orgId ? this.org['name'] + '_' + this.orgId : normalizeOrganizationId(this.user?.organization);
        return '/layout/report/overview/' + org;
      } else {
        return '/layout/report/overview/';
      }
    } else {
      return '/layout/report/overview/'
    }
  }

  getBillingLink() {
    if (this.orgId) {
      if (this.org.parentOrganization && typeof this.org.parentOrganization !== "undefined") {
        let org = this.orgId ? this.org['name'] + '_' + this.orgId : normalizeOrganizationId(this.user?.organization);
        return '/layout/report/billing/' + org;
      } else {
        return '/layout/report/billing/';
      }
    } else {
      return '/layout/report/billing/';
    }
  }

  loadData() {
    this.orgId = normalizeOrganizationId(this.orgId) || normalizeOrganizationId(this.user?.organization);
    this.parentId = normalizeOrganizationId(this.parentId) || this.orgId;
    if (!this.orgId) {
      this.loading = false;
      this.templatesLoading = false;
      this.loadError = 'Organization details are unavailable. Please reopen the report from your organization.';
      return;
    }
    this.loadDataSubscription?.unsubscribe();
    this.historySubscription?.unsubscribe();
    this.loadDataSubscription = new Subscription();
    this.loading = true;
    this.templatesLoading = true;
    this.templatesLoaded = false;
    this.historyLoading = false;
    this.loadError = this.templatesError = this.historyError = '';
    this.jumpDataSource = null;
    this.allOrgData = null;
    this.org = null;
    this.deviceArray = [];
    this.templateDataSource.data = [];
    this.chart?.destroy();
    this.chartLicense?.destroy();
    this.chart = this.chartLicense = null;

    const data = { params: { id: this.orgId } };
    // Template requests run concurrently but cannot hold up the overview charts.
    this.loadDataSubscription.add(forkJoin([
      this.templateService.getQosofOrg(this.orgId),
      this.templateService.getOrganizationOfPrtg(this.orgId),
      this.templateService.getWnetworkofOrg(this.orgId),
      this.templateService.getI4glteofOrg(this.orgId),
      this.templateService.getTeamofOrg(this.orgId)
    ]).subscribe(results => {
      [this.qosArray, this.prtgArray, this.wirelessArray, this.i4glteArray, this.teamsArray] =
        results.map(result => result || []);
      this.templatesLoaded = true;
      if (!this.loading && !this.loadError) {
        this.getTemplateInfo();
        this.templatesLoading = false;
      }
    }, () => {
      this.templatesLoading = false;
      this.templatesError = 'Unable to load templates.';
    }));

    this.loadDataSubscription.add(forkJoin([
      this.userService.getOrganization({ id: this.orgId }),
      this.userService.parentOrganizationList(this.parentId),
      this.apService.getListing(data),
      this.apService.getPendingDevice({ params: { orgId: this.orgId } })
    ]).subscribe(results => {
      this.org = results[0]?.data?.[0];
      if (!this.org) {
        this.loading = this.templatesLoading = false;
        this.loadError = 'Organization details are unavailable.';
        return;
      }
      this.allOrgData = this.org.subOrganizations || [];
      this.orgDataSource = this.allOrgData;
      this.getAllOrgCatInfo();
      this.hasParentOrg = [...(results[1] || [])].sort((a, b) => a.role - b.role);
      this.parentOrg = this.hasParentOrg.filter(org => org._id == this.orgId);
      this.deviceArray = (results[2]?.data || []).map(device => ({
        ...device,
        upTime: this.uptimeToStr(device.statistics ? device.statistics.upTime : device.upTime),
        status: this.getStatus(device.lastSeen, device.track)
      }));
      this.pendingDeviceCnt = (results[3]?.data || [])
        .filter(device => this.org.role == 0 || device.orgId == this.orgId).length;
      this.loading = false;
      this.drawDeviceChart();
      this.drawLicenseChart();
      if (this.templatesLoaded) {
        this.getTemplateInfo();
        this.templatesLoading = false;
      }
      this.setTopNavMenu();
      if (this.selectedReportTab === 2) this.loadHistory();
    }, () => {
      this.loading = this.templatesLoading = false;
      this.loadError = 'Unable to load the overview. Please try again.';
    }));
  }

  onReportTabChange(index: number) {
    this.selectedReportTab = index;
    if (index === 2) this.loadHistory();
  }

  loadHistory() {
    if (this.loading || this.loadError || this.historyLoading || this.jumpDataSource != null) return;
    this.historyLoading = true;
    this.historyError = '';
    this.historySubscription = this.apService.getDeviceBrowseHistory({ params: { id: this.orgId } })
      .subscribe(response => {
        const history = response?.data || [];
        const organization = this.parentOrg?.[0] || this.org;
        if (organization.role == 0) {
          this.jumpDataSource = history;
        } else if (organization.role == 1) {
          const names = new Set(this.getDomainOrg(organization).slice(1).map(org => org.name));
          this.jumpDataSource = history.filter(row => names.has(row.msp_name) || names.has(row.org_name));
        } else {
          this.jumpDataSource = history.filter(row =>
            row.msp_name == organization.name || row.org_name == organization.name);
        }
        this.historyLoading = false;
      }, () => {
        this.historyLoading = false;
        this.historyError = 'Unable to load jump access logs.';
      });
  }

  getDomainOrg(domain) {
    let filteredOrg = [];
    filteredOrg.push(domain)
    for (let i = 0; i < (domain.subOrganizations || []).length; i++) {
      let org = domain.subOrganizations[i];
      filteredOrg = [...filteredOrg, ...this.getDomainOrg(org)]
    }
    return filteredOrg;
  }

  uptimeToStr(input) {
    if (input == null) {
      return '-';
    }
    let day, hour, minutes, seconds, n;
    n = Math.floor(input);
    day = Math.floor(n / (24 * 3600));
    n = Math.floor(n % (24 * 3600));
    hour = Math.floor(n / 3600);
    n = Math.floor(n % 3600);
    minutes = Math.floor(n / 60);
    n = Math.floor(n % 60);
    seconds = n;
    let str = '';
    str = str + (day ? day + 'd ' : '');
    str = str + (hour ? hour + 'h ' : '');
    str = str + (minutes ? minutes + 'm ' : '');
    str = str + (seconds ? seconds + 's' : '');
    return str;
  }

  getDeviceCount(org) {
    let cnt = 0;
    let orgList = this.getDomainOrg(org);
    for (let i = 0; i < this.deviceArray.length; i++) {
      for (let j = 0; j < orgList.length; j++) {
        if (this.deviceArray[i].orgId == orgList[j]._id) {
          cnt += 1;
        }
      }
    }
    return cnt;
  }

  getAllOrgCatInfo() {
    if (!this.org) {
      return;
    }
    let allOrgData = this.getDomainOrg(this.org);
    allOrgData.shift()
    let vendor = 0, msp = 0, org = 0;
    allOrgData.forEach(o => {
      if (o.role == 1) {
        vendor++;
      } else if (o.role == 2) {
        msp++;
      } else if (o.role == 3) {
        org++;
      }
    })
    let data = []
    let txt = "";
    if (vendor) {
      data.push({
        type: "Master MSP",
        count: vendor
      })
    }
    if (msp) {
      data.push({
        type: "MSP",
        count: msp
      })
    }
    if (org) {
      data.push({
        type: "Organization",
        count: org
      })
    }
    this.orgCatDataSource.data = data;
  }

  getTemplateInfo() {
    let t_monitor_count = 0, t_wifi_count = 0, t_qos_count = 0, t_i4glte_count = 0, t_teams_count = 0;
    const prtgIds = new Set(this.prtgArray.map(template => template._id));
    const wirelessIds = new Set(this.wirelessArray.map(template => template._id));
    const lteIds = new Set(this.i4glteArray.map(template => template._id));
    const teamIds = new Set(this.teamsArray.map(template => template._id));
    const qosIds = new Set(this.qosArray.map(template => template._id));
    this.deviceArray.forEach(device => {
      if (prtgIds.has(device.prtg)) t_monitor_count++;
      if (device.assignedWnetwork && wirelessIds.has(device.wnetwork)) t_wifi_count++;
      if (device.i4glte && lteIds.has(device['4glte'])) t_i4glte_count++;
      if (device.teams && teamIds.has(device.team)) t_teams_count++;
      if (device.qos && qosIds.has(device.qos)) t_qos_count++;
    });
    this.templateDataSource.data = [
      {
        't_type': "Team Template",
        't_count': this.teamsArray.length,
        't_device_count': t_teams_count
      },
      {
        't_type': "Monitoring Template",
        't_count': this.prtgArray.length,
        't_device_count': t_monitor_count
      },
      {
        't_type': "WiFi Template",
        't_count': this.wirelessArray.length,
        't_device_count': t_wifi_count
      },
      {
        't_type': "QoS Template",
        't_count': this.qosArray.length,
        't_device_count': t_qos_count
      },
      {
        't_type': "4GLTE Template",
        't_count': this.i4glteArray.length,
        't_device_count': t_i4glte_count
      }
    ]
  }

  ngOnDestroy(): void {
    this.pageAvailable = false;
    this.historySubscription?.unsubscribe();
    this.chart?.destroy();
    this.chartLicense?.destroy();
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
